import { connect } from 'react-redux';
import { getPaginationQueryOptions } from '../../redux/selectors/download-request/pagination';
import {
  getIsFetching,
  getDownloadRequestsQuery
} from '../../redux/selectors/download-request';
import {
  getUserSearchOptions,
  getIsFetching as getIsFetchingSearchOptions
} from '../../redux/selectors/download-request/search-option';
import {
  fetchDownloadRequests,
  fetchDownloadRequestsSearchOptions
} from '../../redux/sagas/download-request/routines';
import {
  setDownloadRequestsQuery,
  clearDownloadRequests
} from '../../redux/actions/download-request';
import DownloadRequestSearch from '../../components/DownloadRequestSearch';

function mapStateToProps(state, props) {
  const searchQuery = getDownloadRequestsQuery(state);
  const paginationQuery = getPaginationQueryOptions(state);
  const queryOptions = { ...paginationQuery, ...searchQuery, page: 1 };
  return {
    ...props,
    searchQuery,
    queryOptions,
    userOptions: getUserSearchOptions(state),
    isFetching: getIsFetching(state),
    isFetchingSearchOptionsOptions: getIsFetchingSearchOptions(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: context => {
      dispatch(fetchDownloadRequestsSearchOptions({ context }));
    },
    onSubmit: queryOptions => {
      dispatch(clearDownloadRequests());
      dispatch(fetchDownloadRequests(queryOptions));
    },
    onChange: query => {
      dispatch(setDownloadRequestsQuery(query));
    },
    onReset: context => {
      dispatch(setDownloadRequestsQuery({ context }));
      dispatch(clearDownloadRequests());
      dispatch(fetchDownloadRequests({ context }));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadRequestSearch);
